import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getCommentTagList, getStationGroupList, createCommentTag, updateCommentTag, delCommentTag, getTagTypeList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'BairunCommentTag',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationGroupName: function getStationGroupName(stationGroupNo) {
      for (var i = 0; i < _this.stationGroupOptions.length; i++) {
        if (_this.stationGroupOptions[i].stationGroupNo === stationGroupNo) {
          return _this.stationGroupOptions[i].stationGroupName;
        }
      }

      return '';
    },
    getCommentTagTypeName: function getCommentTagTypeName(commentTagType) {
      for (var i = 0; i < _this.tagTypeOptions.length; i++) {
        if (_this.tagTypeOptions[i].commentTagType === commentTagType) {
          return _this.tagTypeOptions[i].commentTagTypeName;
        }
      }

      return '';
    },
    getCommentTagTypeColor: function getCommentTagTypeColor(commentTagType) {
      if (commentTagType == 1) {
        return 'warning';
      }

      if (commentTagType == 2) {
        return 'success';
      }

      if (commentTagType == 3) {
        return 'primary';
      }

      if (commentTagType == 4) {
        return 'info';
      }

      if (commentTagType == 5) {
        return 'danger';
      }

      return 'primary';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getCommentTagList,
      dialogVisible: false,
      dialogTitle: '',
      type: '',
      stationGroupOptions: [],
      tagTypeOptions: [],
      formData: {
        commentTagNo: '',
        stationGroupNo: '',
        commentTagName: '',
        commentTagType: 1,
        commentTagGoodsType: 1
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationGroupOptions, tagTypeOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationGroupList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationGroupOptions = _context3.sent;
                _this3.stationGroupOptions = stationGroupOptions.data.list;
                _context3.next = 6;
                return getTagTypeList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 6:
                tagTypeOptions = _context3.sent;
                _this3.tagTypeOptions = tagTypeOptions.data.list;

                _this3.onSubmit();

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    onAdd: function onAdd() {
      this.dialogVisible = true;
      this.dialogTitle = '新增';
      this.type = 'add';

      if (this.stationGroupOptions.length === 1) {
        this.formData.stationGroupNo = this.stationGroupOptions[0].stationGroupNo;
      }
    },
    onUpdate: function onUpdate(row) {
      this.dialogVisible = true;
      this.dialogTitle = '变更';
      this.type = 'update';
      this.formData = JSON.parse(JSON.stringify(row));
    },
    onDel: function onDel(row) {
      var _this4 = this;

      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return delCommentTag(row);

              case 2:
                res = _context4.sent;

                _this4.enterDialogRepose(res);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.dialogTitle = '';
      this.type = '';
      this.formData = {
        commentTagNo: '',
        stationGroupNo: '',
        commentTagName: '',
        commentTagType: 1,
        commentTagGoodsType: 1
      };
    },
    enterDialog: function enterDialog() {
      var that = this;

      switch (that.type) {
        case 'add':
          that.handleAdd();
          break;

        case 'update':
          that.handleUpdate();
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this5.formData.stationGroupNo == '' && _this5.stationGroupOptions.length === 1) {
                  _this5.formData.stationGroupNo = _this5.stationGroupOptions[0].stationGroupNo;
                }

                if (!(_this5.formData.stationGroupNo == '')) {
                  _context5.next = 4;
                  break;
                }

                _this5.$message({
                  type: 'error',
                  message: '请选择油站集团'
                });

                return _context5.abrupt("return");

              case 4:
                if (!(_this5.formData.commentTagName.trim() == '')) {
                  _context5.next = 7;
                  break;
                }

                _this5.$message({
                  type: 'error',
                  message: '标签名称不能为空'
                });

                return _context5.abrupt("return");

              case 7:
                createCommentTag({
                  'stationGroupNo': parseInt(_this5.formData.stationGroupNo),
                  'commentTagName': _this5.formData.commentTagName,
                  'commentTagType': parseInt(_this5.formData.commentTagType),
                  'commentTagGoodsType': parseInt(_this5.formData.commentTagGoodsType)
                }).then(function (res) {
                  if (res.code == 0) {
                    _this5.$message({
                      type: 'success',
                      message: res.msg
                    });

                    _this5.enterDialogRepose(res);
                  }
                }, function (error) {});

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 修改保存
    handleUpdate: function handleUpdate() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this6.formData.stationGroupNo == '')) {
                  _context6.next = 3;
                  break;
                }

                _this6.$message({
                  type: 'error',
                  message: '请选择油站集团'
                });

                return _context6.abrupt("return");

              case 3:
                if (!(_this6.formData.commentTagName.trim() == '')) {
                  _context6.next = 6;
                  break;
                }

                _this6.$message({
                  type: 'error',
                  message: '标签名称不能为空'
                });

                return _context6.abrupt("return");

              case 6:
                updateCommentTag({
                  'commentTagNo': _this6.formData.commentTagNo,
                  'stationGroupNo': parseInt(_this6.formData.stationGroupNo),
                  'commentTagName': _this6.formData.commentTagName,
                  'commentTagType': parseInt(_this6.formData.commentTagType),
                  'commentTagGoodsType': parseInt(_this6.formData.commentTagGoodsType)
                }).then(function (res) {
                  if (res.code == 0) {
                    _this6.$message({
                      type: 'success',
                      message: res.msg
                    });

                    _this6.enterDialogRepose(res);
                  }
                }, function (error) {});

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};